<template>
	<div class="pageContainer">
		<PageHeader
			addClass="is-platform"
			:image="require('../assets/business_platform/title_pc.svg')"
			:imageSp="require('../assets/business_platform/title_sp.svg')"
			alt="最上流から、現場の定着まで。「世界標準」の技術で、クライアントをリードする。"
			intro="ビジネスプラットフォーム領域は、<br class='over_display'>大手企業を中心としたクライアント企業に対し、<br class='over_display'>コンサルティング・基幹システム刷新・教育を柱にしたソリューションを提供しています。<br>この領域の概要、強み、代表的なプロジェクト事例や組織体制について、<br class='over_display'>余すところなく紹介します。"
		/>
		<BgTitleBox
			:bgPc="require('../assets/business_platform/bgBox_pc.jpg')"
			:bgSp="require('../assets/business_platform/bgBox_sp.jpg')"
			title="ビジネスプラットフォーム領域の概要"
		/>
		<BusinessPlatformArticle />
	</div>
</template>

<script>
import PageHeader from '@/components/mainpage/PageHeader.vue';
import BusinessPlatformArticle from '@/components/mainpage/BusinessPlatformArticle.vue';
import BgTitleBox from '@/components/common/BgTitleBox.vue';
export default {
	name: 'business_platform',
	components: {
		PageHeader,
		BusinessPlatformArticle,
		BgTitleBox,
	},
};
</script>

<style lang="scss" scoped>
.pageContainer {
	position: relative;
	overflow: hidden;
	width: 100%;
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 100px;
	}
	&::after {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		bottom: 0;
		left: 0;
		transform: skewY(-18deg);
		transform-origin: left top;
		z-index: -1;
		@media print, screen and (min-width: 1161px) {
			bottom: 0px;
		}
	}
}
</style>
